// extracted by mini-css-extract-plugin
export default {"debug":"src-client-theme-core-___default__debug___eMjrH","header":"src-client-theme-core-___default__header___6sxRC"};